function ResourceMeedyVO(id, medicalPost, name, shortName, defaultAppointmentLength, address, phone, mobilePhone, fax, email, www,
                         color, user, firstSpecialization, secondSpecialization, thirdSpecialization, fourthSpecialization,
                         acceptsAgeFrom, acceptsAgeTo, title, firstName, lastName, aboutMe, experience, pictureUrl, pwz,
                         identifier, hasAvailabilityRule, hasVacation, resourceDetails, minDaysBeforeReservation,
                         useMedicalPostAddressData) {

    this.id = id;
    this.medicalPost = medicalPost;
    this.name = name;
    this.shortName = shortName;
    this.defaultAppointmentLength = defaultAppointmentLength;
    this.address = address;
    this.phone = phone;
    this.mobilePhone = mobilePhone;
    this.fax = fax;
    this.email = email;
    this.www = www;
    this.color = color;

    this.user = user;
    this.firstSpecialization = firstSpecialization;
    this.secondSpecialization = secondSpecialization;
    this.thirdSpecialization = thirdSpecialization;
    this.fourthSpecialization = fourthSpecialization;
    this.acceptsAgeFrom = acceptsAgeFrom;
    this.acceptsAgeTo = acceptsAgeTo;
    this.title = title;
    this.firstName = firstName;
    this.lastName = lastName;
    this.aboutMe = aboutMe;
    this.experience = experience;
    this.pictureUrl = pictureUrl;
    this.identifier = identifier;
    this.pwz = pwz;
    this.hasAvailabilityRule = hasAvailabilityRule;
    this.hasVacation = hasVacation;
    this.resourceDetails = resourceDetails;
    this.minDaysBeforeReservation = minDaysBeforeReservation;
    this.useMedicalPostAddressData = useMedicalPostAddressData;


    var _typeContext = {
        medicalPost : MedicalPostMeedyVO,
        address : AddressMeedyVO,
        user: UserMeedyVO,
        firstSpecialization: SpecializationMeedyVO,
        secondSpecialization: SpecializationMeedyVO,
        thirdSpecialization: SpecializationMeedyVO,
        fourthSpecialization: SpecializationMeedyVO,
        resourceDetails: ResourceDetailsMeedyVO
    };

    this._getType = function(property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
